<template>
   <div>
      <div style="font-weight: lighter; font-size: small;">
         <button :class="{ 'mb': true, 'is-active': isActive('bold') }"  @click="command('bold')">
            <i class="material-icons">format_bold</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('italic') }"  @click="command('italic')">
            <i class="material-icons">format_italic</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('underline') }"  @click="command('underline')">
            <i class="material-icons">format_underline</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('strike') }"  @click="command('strike')">
            <i class="material-icons">format_strikethrough</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('heading({ level: 1 })'), 'align-top': true }"
             @click="command('h1')">
            <i class="mi-heading">H1</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('bullet_list') }"  @click="command('bullet_list')">
            <i class="material-icons">format_list_bulleted</i>
         </button>
         <button :class="{ 'mb': true, 'is-active': isActive('ordered_list') }"  @click="command('ordered_list')">
            <i class="material-icons">format_list_numbered</i>
         </button>
         <button class="mb"  @click="command('undo')">
            <i class="material-icons">undo</i>
         </button>
         <button class="mb"  @click="command('redo')">
            <i class="material-icons">redo</i>
         </button>
      </div>
   </div>
</template>

<script>

// SEE THIS: https://github.com/ueberdosis/tiptap
// SEE THIS: https://tiptap.dev/docs/api/extensions.html#orderedlist

import { Editor, EditorContent } from '@tiptap/vue-2'

export default {
   name: 'EditorMenu',
   props: { editor: Object },
   data() {
      return {
         selected: 1
      }
   },
   computed: {

   },
   methods: {
      command(cmdKey) {
         let url = ''
         let file = ''
         if (this.selectedImage) {
            file = `${this.selectedImage.corrTemplateImageId}.${this.selectedImage.imageTypeCode}`
            url = `${this.imgUrlPrefix}${file}`
         }
         let c
         if (this.selectedField) {
            c = this.baseField.replace('@', '@' + this.selectedField.label)
         }

         switch (cmdKey) {
            case 'bold':
               this.editor.chain().focus().toggleBold().run()
               break
            case 'italic':
               this.editor.chain().focus().toggleItalic().run()
               break
            case 'underline':
               this.editor.chain().focus().toggleUnderline().run()
               break
            case 'strike':
               this.editor.chain().focus().toggleStrike().run()
               break
            case 'h1':
               break
            case 'bullet_list':
               this.editor.chain().focus().toggleBulletList().run()
               break
            case 'ordered_list':
               this.editor.chain().focus().toggleOrderedList().run()
               break
            case 'undo':
               this.editor.chain().focus().undo().run()
               break
            case 'redo':
               this.editor.chain().focus().redo().run()
               break
         }         
      },
      isActive(actKey) {
         if (this.editor)
            return this.editor.isActive(actKey)
         return false
      },
   }
}
</script>

<style lang="scss" scoped>
@import '~material-design-icons/iconfont/material-icons.css';

.mi-heading {
   color: #000;
   line-height: 30px;
   font-size: 20px;
   font-style: normal;
   vertical-align: middle;
   margin: 0;
}</style>